import NgpTextField from './NgpTextField';

export default function NgpTextarea(props) {
    const { inputProps, rows, cols } = props;
    const theInputProps = { ...inputProps, rows, cols };
    return <NgpTextField {...props} inputProps={theInputProps} multiline />;
}
